import React from 'react'
import { dummyCards } from '../dummyCards';
import {useLocation} from 'react-router-dom';
const CardFullView = () => {
    const location=useLocation();
  return (
    <>

        {console.log(location.state.id)}
        {console.log(location.state.name)}
        {console.log(location.state.description)}
        {console.log(location.state.imageUrl)}
        {console.log(location.state.value)}
        {console.log(location.state.set)}
        {console.log(location.state.condition)}
          <div className="card-full">
            <div className="card-images">
              {/* carousel of images goes here */}
            </div>
            <div className="card-details">
              <h1 className="card-name">{location.state.name}</h1>
              <img className="card-image" src={location.state.imageUrl} alt={location.state.name} />
              <p className="card-set">{location.state.set}</p>
              <p className="card-value">{location.state.value}</p>
              <p className="card-condition">{location.state.condition}</p>
              {/* more detailed information goes here */}
            </div>
          </div>
          </>
        );
      }
 

export default CardFullView